import { styled } from '@mui/material/styles';
import { ToggleButtonGroup } from '@mui/material';

export const StyledButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: '#f0f0f0',
  padding: '4px',
  borderRadius: '8px',
  width: '100%',
  '& .MuiToggleButton-root': {
    border: 'none',
    borderRadius: '6px',
    flex: 1,
    textTransform: 'none',
    fontWeight: 'bold',
    '&.Mui-selected': {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
      boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
      '&:hover': {
        backgroundColor: '#fff',
      },
    },
  },
}));
